import React from 'react';

import Arrow from '../shared/arrow/Arrow';
import Icon from '../shared/icon/Icon';

class Footer extends React.Component<{}, {}> {
    public render() {
        return (
            <footer className="main-footer main-footer--internal">
                <div className="w--lg w--lg--confined">
                    <div className="flex-grid">
                        <div className="main-footer__column flex-grid__col flex-grid__col--12 flex-grid__col--sm-3">
                            <span className="main-footer__link">
                                <a href="https://di.dk" className="button arrow__wrapper has-icon" target="_blank" rel="noopener noreferrer">
                                    <Arrow modifierClass="icon" />
                                    <span className="text">Til di.dk</span>
                                </a>
                            </span>
                        </div>
                        <div className="main-footer__column flex-grid__col flex-grid__col--12 flex-grid__col--sm-6 align-center--text">
                            <p>H. C. Andersens Boulevard 18, 1787 København V</p>
                        </div>
                        <div className="main-footer__column flex-grid__col flex-grid__col--12 flex-grid__col--sm-3 align-right">
                            <div className="main-footer__logo">
                                <div className="icon theme--local theme-didk2023">
                                    <Icon name="logo" isV2={true} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </footer>
        )
    }
}

export default Footer;